import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import Divider from '@mui/material/Divider';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import PolicyOutlinedIcon from '@mui/icons-material/PolicyOutlined';
import Logout from '@mui/icons-material/Logout';
import { useNavigate } from 'react-router-dom';
import Badge from '@mui/material/Badge';
import { useLocation } from 'react-router-dom';

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    border: '1px solid #356AC3',
    marginTop: theme.spacing(1),
    minWidth: 180,
    color: 'black',
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: 'black',
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
      },
    },
    ...theme.applyStyles('dark', {
      color: theme.palette.grey[300],
    }),
  },
}));

export default function AccountDropDown({ profilePage, handleLogout, verticals }) {
  const location = useLocation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const navigate = useNavigate();

  const handleButtonClick = (url) => {
    window.open(url, '_blank');
  };

  return (
    <div>
      <div
        className={`navLink ${
          open || location.pathname.includes('profile') ? 'navLinkActive' : ''
        }`}
        id="demo-customized-button"
        onClick={handleClick}
        aria-controls={open ? 'demo-customized-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
      >
        <Badge
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          badgeContent={verticals?.filter((v) => v.status === 'Invited').length}
          max={9999}
          slotProps={{
            badge: {
              sx: {
                backgroundColor: '#356AC3',
                color: 'white',
                top: '',
                border: '1px solid #356AC3',
                fontSize: '12px',
                fontWeight: '500',
              },
            },
          }}
        >
          <img src={`${process.env.PUBLIC_URL + '/navBar/account.svg'}`} alt="Account" />
        </Badge>
        <span>Account</span>
      </div>
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          'aria-labelledby': 'demo-customized-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem
          onClick={() => {
            navigate(profilePage);
            handleClose();
          }}
          disableRipple
        >
          <AccountCircleOutlinedIcon />
          My Profile
        </MenuItem>
        <Divider sx={{ my: 0.5 }} />
        <MenuItem
          onClick={() => {
            handleButtonClick('https://www.simple-platform.com/terms-and-conditions');
            handleClose();
          }}
          disableRipple
        >
          <ArticleOutlinedIcon />
          Terms and Conditions
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleButtonClick('https://www.simple-platform.com/privacy-policy');
            handleClose();
          }}
          disableRipple
        >
          <PolicyOutlinedIcon />
          Privacy Policy
        </MenuItem>
        <Divider sx={{ my: 0.5 }} />
        <MenuItem onClick={handleLogout} disableRipple>
          <Logout />
          Log Out
        </MenuItem>
      </StyledMenu>
    </div>
  );
}
